import React, { useState } from 'react';
import i18n from '../i18n/i18n.jsx';
import './Langswitch.css'; // Import CSS for styling

const LanguageSwitcher = () => {
  const [language, setLanguage] = useState('en');

  const handleChangeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setLanguage(lng);
  };

  const handleToggleLanguage = () => {
    const newLanguage = language === 'en' ? 'fr' : 'en';
    handleChangeLanguage(newLanguage);
  };

  return (
    <div className="language-switcher">
      <div className="switch-container">
        <span className="label label-left">Eng</span>
        <label className="switch-key">
          <input 
            type="checkbox" 
            checked={language === 'fr'} 
            onChange={handleToggleLanguage} 
          />
          <span className="key"></span>
        </label>
        <span className="label label-right">French</span>
      </div>
    </div>
  );
};

export default LanguageSwitcher;
